import React, { useState, useEffect } from 'react';
import Typography from '@material-ui/core/Typography';
import Content from 'components/Content';
import { TextField, Button, Grid, ListItemIcon, ListItemText, OutlinedInput, FormControl, InputLabel, Paper } from '@material-ui/core/';
import { sendGetRequest } from '../utils/api';
import BasicDropDown from '..//components/forms/formElements/BasicDropDown';
import _ from 'lodash';
import { useTheme } from '@material-ui/core/styles';

import {
	LineChart,
	Line,
	XAxis,
	YAxis,
	Label,
	Tooltip,
	ResponsiveContainer,
    PieChart,
    Pie,
    Cell,
    Legend,
    Bar,
    CartesianGrid,
    BarChart,
} from 'recharts';

import { ContactsOutlined } from '@material-ui/icons';


const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#d0eff2", "#81948c", "#dee3a6"];

const RADIAN = Math.PI / 180;

const renderCustomizedLabel1 = (item)=>{
    console.log("ITEM", item["Business Unit"].value);
    const radius = item.innerRadius + (item.outerRadius - item.innerRadius) * 0.5;
    const x = item.cx + radius * Math.cos(-item.midAngle * RADIAN);
    const y = item.cy + radius * Math.sin(-item.midAngle * RADIAN);
    const clickItem = () =>{
      alert();
    }
    return (
      <text
        x={x}
        y={y}
        fill="white"
        textAnchor={x > item.cx ? "start" : "end"}
        dominantBaseline="central"
       
      >
        {`${(item.percent * 100).toFixed(0)}%`}
       
      </text>
    );
  }

  const renderCustomizedLabel2 = (item)=>{
     
    const { payload } = item;
        const spaces = "    ";
        return (
            <ul>
                {
                    payload.map((entry, index) => {
                        console.log("ENTRY", entry)
                        return(
                            <li key={`item-${index}`} style={{"color":`${entry.color}`, "marginRight":"25px"}}>
                                <h5>{entry.payload["Business Unit"].value}</h5>
                                <h6>TOTAL COST = {entry.payload["Total Cost"]}</h6>
                                <h6>TOTAL ITEM COUNT = {entry.payload["Total Item Count"]}</h6>
                            </li>
                        )
                    }
                    
                    )
                }
            </ul>
        );
  }

  const renderCustomizedLabel3 = (item)=>{
     
    const { payload } = item;
        
        return (
            <>
                {
                    payload.map((entry, index) => {
                        console.log("ENTRY", entry)
                        return(
                            <div key={`item-${index}`} style={{"color":`${entry.color}`}}>
                                <h5 style={{"color":`${entry.color}`}}>
                                    {entry.payload["Business Unit"].value}
                                </h5>
                                
                                
                                
                            </div>
                        )
                    }
                    
                    )
                }
            </>
        );
  }

export default function OverallReport(props) {
	const theme = useTheme();
	const [rows, setRows] = useState([]);

    const [mainData, setMainData] = useState([]);
    const [businessUnits, setBusinessUnits] = useState([]);
    const [filter, setFilter] = useState({businessUnit: 'Hedcor Group'});

    const [itemCountPerBusinessUnit, setItemCountPerBusinessUnit] = useState([]);
    
    const [itemCountPerMonth, setItemCountPerMonth] = useState([]);

    const [itemsPerStatus, setItemsPerStatus] = useState([]);

    useEffect(() => {
        
        const getDataFromServer = async () =>{
            const res = await sendGetRequest(`/reports/overall`);
            if(res){
                setMainData(res.data);
            }
        }

        if(localStorage.getItem('businessUnits')){
            const items = JSON.parse(localStorage.getItem('businessUnits'));
            setBusinessUnits(items);
            
            console.log(items);
        }

        getDataFromServer();

		
        
    }, []);

    useEffect(() => {

    }, [mainData]);


    useEffect(() => {

        if(!_.isEmpty(businessUnits) && !_.isEmpty(mainData)){
            console.log("PREPPING DATA");
            let assetStats;

            if(localStorage.getItem('AssetStat')){
                assetStats = JSON.parse(localStorage.getItem('AssetStat')); 
            }


            //PER BU DATA
            const tempItemsBu = [];
            for(let bu of businessUnits){
                const items = mainData.filter((i) => i.businessUnit === bu.value)

                const total_cost_of_items = items.reduce((a, b) => a + b.acqCost, 0);
                if(items.length > 0){
                    tempItemsBu.push({
                        "Total Item Count": items.length,
                        "Total Cost": total_cost_of_items,
                        "Business Unit": bu
                    });
                    // tempItemsBu.push({
                    //     name: bu,
                    //     value: items.length
                    // });
                }
            }
            
            setItemCountPerBusinessUnit(tempItemsBu);

            //PER MONTH DATA
            const tempItems = [];
			const tempMonths = [1,2,3,4,5,6,7,8,9,10,11,12];
			const months = ['','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
			for(let month of tempMonths){
				const tempRows = mainData.filter((item) => item.month === month);
                const total_cost = tempRows.reduce((a, b) => a + b.acqCost, 0);

				if(tempRows.length === 0){
					tempItems.push({
						"Month": months[month],
						"Total": 0,
						"Total Item Count": 0
					});
				}else{
					tempItems.push({
						"Month": months[month],
						"Total": total_cost,
						"Total Item Count": tempRows.length
					});
				}

			}
            console.log(tempItems)
			setItemCountPerMonth(tempItems);

            

            //TO DO: Middleware - Once a FAMAS doc is approved, update all previous FAMAS ITEMS as inactive in all FAMAS Docs and update the status of the new FAMAS Doc
            //Update masterlist item based on the status of items in the NEW FAMAS DOC
            
            const stats = ['OPERATIONAL','RETIRED','DEFECTIVE','DISPOSED','TRANSFERRED','REPAIRED','BID'];

            //PER ASSET STAT DATA
            const tempItemsStat = [];
            for(let i = 0; i < stats.length; i++){

                const tempItem = mainData.filter((asset) => asset.assetStat === stats[i]);
                const tempCost = tempItem.reduce((a, b) => a + b.acqCost, 0);

                tempItemsStat.push({
                    "Status": stats[i],
                    "Total Cost": tempCost,
                    "Total Items": tempItem.length
                });

            }
            console.log("STAT ITEMS", tempItemsStat)
            setItemsPerStatus(tempItemsStat);
        }

    }, [businessUnits, mainData]);

    useEffect(() => {

        const getDataFromServer = async () =>{

            const res = await sendGetRequest(`/reports/overall?business_unit=${filter.businessUnit}`);
            if(res){
                setMainData(res.data);
                console.log(res.data);
            }
        }
        getDataFromServer();
        
    }, [filter])

	useEffect(() => {
		
		if(props.data){
			
			const tempItems = [];
			const tempMonths = [1,2,3,4,5,6,7,8,9,10,11,12];
			const months = ['','Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
			for(let month of tempMonths){
				const tempRows = props.data.filter((item) => item.month === month);
				if(tempRows.length === 0){
					tempItems.push({
						
						Month: months[month],
						Total : 0,
						"Total Count": 0
					});
				}else{
					tempItems.push({
						
						Month: months[tempRows[0].month],
						Total: tempRows[0].total,
						"Total Count": tempRows[0].totalCount
					});
				}

			}
			console.log(tempItems);

			setRows(tempItems);
		}

		return () => {
		
		}
	}, [props.data])

    const handleChange = (e) =>{
    
        setFilter({businessUnit: e.target.value});

    }

    const renderLegend = () => {
        const { payload } = itemCountPerBusinessUnit;
        const spaces = "    ";
        return (
            <ul>
                {
                    payload.map((entry, index) => {
                        console.log(entry);
                        return(
                            <li key={`item-${index}`} style={{"color": `${entry["Business Unit"].color}` }}>
                                {entry["Business Unit"]}
                            </li>
                        )
                    }
                    
                    )
                }
            </ul>
        );
    }
	return (
		<Content>
			<Typography component="h2" variant="h6" color="primary" gutterBottom>
			    Overall 
		    </Typography>
            <Grid 
                container
				direction="column"
				justifyContent="flex-start"
				alignItems="center"
				spacing={3}
            >
                {/* <Grid item xs={12} md={12}>
                    <BasicDropDown 
						name="businessUnit"
						label="Business Unit"
						value={filter.businessUnit || ' '}
						onChange={(e)=>handleChange(e)}
						options={businessUnits}
						
					/>
                </Grid> */}
                <Grid item xs={12} md={12} >
                    <Paper>
                    <Typography component="h2" variant="h6" color="primary" gutterBottom style={{padding:"10px"}}>
			            FAMAS Created Per Month 
		            </Typography>
                    <div style = {{height:"350px", width:"800px"}}>
                        <ResponsiveContainer>
                            <LineChart
                                data={itemCountPerMonth}
                                margin={{
                                    top: 16,
                                    right: 16,
                                    bottom: 0,
                                    left: 24,
                                }}
                            >
                               
                                <XAxis dataKey="Month" stroke={theme.palette.text.secondary} />
                                <YAxis stroke={theme.palette.text.secondary}>
                                    <Label
                                        angle={270}
                                        position="left"
                                        style={{ textAnchor: 'middle', fill: theme.palette.text.primary }}
                                    >
                                        FAMAS Documents Created 
                                    </Label>
                                </YAxis>
                                <Tooltip />
                                <Line
                                    type="monotone"
                                    dataKey="Total Item Count"
                                    stroke={theme.palette.primary.main}
                                    activeDot={{ r: 8 }}
                                />
                                <Legend />
                            </LineChart>
                        </ResponsiveContainer>
                    </div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={12}>
                    <Paper>
                    <Typography component="h2" variant="h6" color="primary" gutterBottom style={{padding:"10px"}}>
			            Per Business Unit
		            </Typography>
                    <div style = {{height:"400px", width:"800px"}}>
                        <ResponsiveContainer width="100%" height="100%">
                        <PieChart width={400} height={400}>
                            <Pie
                                labelLine={false}
                                dataKey="Total Item Count"
                                isAnimationActive={false}
                                data={itemCountPerBusinessUnit}
                                cx="200"
                                cy="200"
                                fill="#8884d8"
                                label = {renderCustomizedLabel1}
                            >
                                {itemCountPerBusinessUnit.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]}/>
                                ))}
                            </Pie>
                            <Tooltip content={renderCustomizedLabel3}/>
                            <Legend content={renderCustomizedLabel2} layout='bottom' verticalAlign="bottom" align="right"/>
                        </PieChart>
                        </ResponsiveContainer>
                    
                    </div>
                    </Paper>  
                </Grid>

                <Grid item xs={12} md={12}>
                <Paper>
                    <Typography component="h2" variant="h6" color="primary" gutterBottom style={{padding:"10px"}}>
			            Per Asset Status
		            </Typography>
                    <div style = {{height:"400px", width:"800px"}}>
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart
                            width={500}
                            height={300}
                            data={itemsPerStatus}
                            margin={{
                                top: 5,
                                right: 30,
                                left: 20,
                                bottom: 5,
                            }}
                            >
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey="Status" />
                            <YAxis />
                            <Tooltip />
                            <Legend />
                            <Bar dataKey="Total Cost" fill="#8884d8" />
                            <Bar dataKey="Total Items" fill="#82ca9d" />
                            </BarChart>
                        </ResponsiveContainer>
                     
                    </div>
                    </Paper>  
                </Grid>
            </Grid>
			
        </Content>
	);
}
